import { Colors, FontsSizes, FontsWeights, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import MoneyWithCurrency, { isCurrency } from 'modules/core/lib/money'

interface IAmount {
  amount: number | undefined | null
  currency: string
  size?: FontsSizes
  weight?: FontsWeights
  color?: Colors
  italic?: boolean
  optionalDecimals?: boolean
}
export const Amount = ({
  amount,
  currency,
  size,
  weight,
  color,
  italic,
  optionalDecimals = true,
}: IAmount) => {
  const {
    access: { locale },
  } = useCurrentSession()
  return (
    <Text
      size={size ?? '300'}
      weight={weight}
      color={color ?? 'grey800'}
      {...(italic && { fontStyle: 'italic' })}
    >
      {amount && isCurrency(currency)
        ? MoneyWithCurrency({
            optionalDecimals,
            amount,
            currency,
            locale,
          })
        : '-'}
    </Text>
  )
}
